import { combineReducers } from '@reduxjs/toolkit';

import { baseApi } from 'api/api-base';
import notificationReducer from 'store/slices/notification-slice';

import configReducer from './config/config.reducer';
import chartsReducer from './slices/charts-slice';
import dashboardReducer from './slices/dashboard-slice';
import featuresReducer from './slices/features-slice';
import invoicesReducer from './slices/invoice-slice';
import minersReducer from './slices/miners-slice';
import productsReducer from './slices/products-slice';
import transactionsReducer from './slices/transactions-slice';
import userReducer from './slices/user-slice';

const reducer = combineReducers({
  charts: chartsReducer,
  config: configReducer,
  dashboard: dashboardReducer,
  features: featuresReducer,
  invoices: invoicesReducer,
  miners: minersReducer,
  notification: notificationReducer,
  products: productsReducer,
  transactions: transactionsReducer,
  user: userReducer,

  [baseApi.reducerPath]: baseApi.reducer,
});

export default reducer;
